module.exports =
{

  _init: function ()
  {
    
    this.onChangeFields()

  },

  onChangeFields: function ()
  {

    var button = $('#modal-submit')[0]

    $('.js-require').not('.js-ignore').change(function ()
    {

      button.disabled = false

      $('.js-require').each(function ()
      {

        if (-1 !== ['', '0'].indexOf($(this).val()))
        {
          button.disabled = true
        }

      }
      )

    }
    ).addClass('js-ignore')

  }

}